/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationSettingsSettings } from './NotificationSettingsSettings';
import {
    NotificationSettingsSettingsFromJSON,
    NotificationSettingsSettingsFromJSONTyped,
    NotificationSettingsSettingsToJSON,
    NotificationSettingsSettingsToJSONTyped,
} from './NotificationSettingsSettings';

/**
 * User notification preferences by platform and resource type
 * @export
 * @interface NotificationSettings
 */
export interface NotificationSettings {
    /**
     * 
     * @type {number}
     * @memberof NotificationSettings
     */
    readonly id: number;
    /**
     * User these settings belong to
     * @type {number}
     * @memberof NotificationSettings
     */
    userId: number;
    /**
     * Company that owns these settings
     * @type {number}
     * @memberof NotificationSettings
     */
    companyId: number;
    /**
     * 
     * @type {NotificationSettingsSettings}
     * @memberof NotificationSettings
     */
    settings: NotificationSettingsSettings;
    /**
     * 
     * @type {Date}
     * @memberof NotificationSettings
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof NotificationSettings
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the NotificationSettings interface.
 */
export function instanceOfNotificationSettings(value: object): value is NotificationSettings {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('settings' in value) || value['settings'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function NotificationSettingsFromJSON(json: any): NotificationSettings {
    return NotificationSettingsFromJSONTyped(json, false);
}

export function NotificationSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'companyId': json['companyId'],
        'settings': NotificationSettingsSettingsFromJSON(json['settings']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function NotificationSettingsToJSON(json: any): NotificationSettings {
    return NotificationSettingsToJSONTyped(json, false);
}

export function NotificationSettingsToJSONTyped(value?: Omit<NotificationSettings, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'companyId': value['companyId'],
        'settings': NotificationSettingsSettingsToJSON(value['settings']),
    };
}

